
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/pengelolaan-kinerja-landing",
      function () {
        return require("private-next-pages/pengelolaan-kinerja-landing/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/pengelolaan-kinerja-landing"])
      });
    }
  